import React from 'react';

export default () => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.95039 1.12791C4.22118 0.9094 4.26509 0.510848 4.04845 0.237716C3.83182 -0.0354161 3.43668 -0.0796995 3.16589 0.138806L1.07287 1.82769C0.802073 2.0462 0.758169 2.44475 0.974803 2.71788C1.19144 2.99101 1.58657 3.0353 1.85737 2.81679L3.95039 1.12791Z"
      fill="white"
    />
    <path
      d="M14.8341 0.138806C14.5633 -0.0796995 14.1682 -0.0354161 13.9515 0.237716C13.7349 0.510848 13.7788 0.9094 14.0496 1.12791L16.1426 2.81679C16.4134 3.0353 16.8086 2.99101 17.0252 2.71788C17.2418 2.44475 17.1979 2.0462 16.9271 1.82769L14.8341 0.138806Z"
      fill="white"
    />
    <path
      d="M9.62791 6.54446C9.62791 6.19468 9.34679 5.91113 9 5.91113C8.65322 5.91113 8.3721 6.19468 8.3721 6.54446V10.0961C8.3721 10.3653 8.27012 10.6243 8.08703 10.8202L6.86871 12.1236C6.63082 12.3781 6.64252 12.7789 6.89484 13.0188C7.14716 13.2588 7.54456 13.247 7.78245 12.9925L9.00077 11.6891C9.40357 11.2582 9.62791 10.6883 9.62791 10.0961V6.54446Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0.844465C4.02944 0.844465 0 4.90872 0 9.92223C0 14.9357 4.02944 19 9 19C13.9706 19 18 14.9357 18 9.92223C18 4.90872 13.9706 0.844465 9 0.844465ZM1.25581 9.92223C1.25581 5.60828 4.723 2.11113 9 2.11113C13.277 2.11113 16.7442 5.60828 16.7442 9.92223C16.7442 14.2362 13.277 17.7333 9 17.7333C4.723 17.7333 1.25581 14.2362 1.25581 9.92223Z"
      fill="white"
    />
  </svg>
);
